import { NavMenuItem } from "interfaces/dataInterfaces"
import { coreApi } from "./coreApi"

export const navigationMenuApi = coreApi.injectEndpoints({
  endpoints: builder => ({
    getNavMenu: builder.query<NavMenuItem[], void>({
      query: () => ({ url: "NavigationMenu/Get" }),
      providesTags: () => [{ type: "NavigationMenu" as const, id: "DATA" }],
    }),
  }),
})

export const { useGetNavMenuQuery } = navigationMenuApi
